






















































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {Certificate} from '@fidm/x509';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class CertificateDetails extends Mixins<BaseComponent>(BaseComponent) {

  @Prop({default: 'Certificate details'})
  public title!: string;

  @Prop()
  public certificate!: Certificate;

  @Prop({default: false})
  private expanded!: boolean;

  private expandable: boolean = true;

  private mounted() {
    if (this.expanded) {
      this.expandable = false;
    }
  }

  get certificateExpirationDays(): number {
    return Math.ceil((this.certificate.validTo.valueOf() - Date.now().valueOf()) / (1000 * 60 * 60 * 24));
  }
}
